import { Badge } from '@mantine/core';

import type { OperationKind } from '../api/types';
import { KIND_COLOR } from '../theme';

const KIND_LABEL: Record<OperationKind, string> = {
  deposit: 'пополнение',
  withdrawal: 'трата',
};

export function KindBadge({ kind }: { kind: OperationKind }) {
  return (
    <Badge color={KIND_COLOR[kind]} size="sm">
      {KIND_LABEL[kind]}
    </Badge>
  );
}
